import { Stack } from '@mui/material';
import type { FC, ReactNode } from 'react';
import React from 'react';
import { VyDivider } from '../../../../../components/new-design/atoms';

type ConfigurationsContainerProps = {
  children: ReactNode;
};

export const ConfigurationsContainer: FC<ConfigurationsContainerProps> = ({ children }) => {
  const childrenArray = React.Children.toArray(children);

  return (
    <Stack direction="column" divider={<VyDivider />} sx={{
      gap: "30px"
    }}>
      {childrenArray.map((configurationSection, index) => (
        <Stack key={index} direction="column" sx={{
          gap: "30px"
        }}>
          {configurationSection}
        </Stack>
      ))}
    </Stack>
  );
};
